import momentJS from 'moment';

export default function moment(dateStr) {
	return momentJS(dateStr).add(543, 'year').add(-7, 'hour');
}
